export default __webpack_public_path__ + "media/images/mailer-new/heading/reaction-f713e7cb36003059493460cf9c09e254.png";